import { ChatContext, P2GChatLink } from '@parcel2go/peacock-legacy-chat/dist/chat';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GLink } from '@parcel2go/peacock-legacy-core/dist/link';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import { SvgEnquiryError } from '@parcel2go/peacock-legacy-core';
import { P2GTranslation } from '@parcel2go/peacock-legacy-resources/dist/translations';
import React from 'react';
import { Tracking } from '../../services/api/index';
import {
  GetLastTrackingEventTimeStamp,
  GetRelativeTimestampByDays,
  HasEstimatedDeliveryDatePassed
} from '../../services/helpers';
import { P2GAlert } from '@parcel2go/peacock-legacy-core';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface ITrackingIssueMessageProps {
  color?: 'info' | 'warning' | 'error' | 'success',
  message: string,
  orderReference: string | number,
  showChat?: boolean,
  showContact?: boolean,
  helpLink?: string,
  infoLink?: string,
  showOptions: boolean,
  onValidateOrder?: () => void,
  loadChatContext: (profile: string) => Promise<ChatContext>,
  onChatStarted: () => void,
  onChatEnded: (start?: Date | null, end?: Date | null) => void,
  title?: string | null,
  options?: any,
  components?: React.ReactNode[],
  headingVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

const useStyles = makeStyles(() => ({
  iconColour: {
    fill: '#b01515',
    '& svg>path':{
      fill: '#b01515'
    },
    '&>.MuiGrid-container': {
      flexWrap:'nowrap'
    }
  }
}))

export const TrackingIssueMessage: React.FC<ITrackingIssueMessageProps> = (props) => {
  var classes=useStyles();

  return (
    <React.Fragment>
      {props.title &&
        <P2GGrid container spacing={1}>
          <P2GGrid item>
          <P2GText variant={props.headingVariant}><P2GTranslation defaults="" translation={props.title}></P2GTranslation></P2GText>
          </P2GGrid>
        </P2GGrid>
      }
      {props.color !== "info" &&
        <P2GAlert classNames={classes.iconColour} color={props.color ?? "info"} icon={ props.color === "error" ? <SvgEnquiryError /> : "" }>
          <P2GGrid container spacing={1} wrap='nowrap' direction='column'>
            <P2GGrid item>
              <P2GTranslation defaults="" translation={props.message} options={props.options} components={props.components} >
                {props.children}
              </P2GTranslation>
            </P2GGrid>
            {props.showOptions && props.showChat &&
              <P2GGrid item>
                <P2GChatLink
                  loadContext={props.loadChatContext}
                  orderReference={props.orderReference.toString()}
                  onOpenChat={props.onChatStarted}
                  onCloseChat={props.onChatEnded}
                >
                  <P2GTranslation translation="TRACKING.RESULT.ISSUE.CHAT" />
                </P2GChatLink>
              </P2GGrid>
            }
            {props.showOptions && (props.showChat && (props.helpLink || props.infoLink)) &&
              <P2GGrid item>
                /
              </P2GGrid>
            }
            {props.showOptions && props.helpLink &&
              <P2GGrid item>
                <P2GLink href={props.helpLink}><P2GTranslation translation="TRACKING.RESULT.ISSUE.HELP" /></P2GLink>
              </P2GGrid>
            }
            {props.showOptions && props.infoLink &&
              <P2GGrid item>
                <P2GLink href={props.infoLink}><P2GTranslation translation="TRACKING.RESULT.ISSUE.INFO" /></P2GLink>
              </P2GGrid>
            }
            {props.showOptions && props.showContact &&
              <P2GGrid item>
                <P2GTranslation translation="TRACKING.RESULT.ISSUE.CONTACT" />
              </P2GGrid>
            }
            {!props.showOptions && props.onValidateOrder && (props.showChat || props.showContact || props.infoLink || props.helpLink) &&
              <P2GGrid item>
                <P2GLink onClick={props.onValidateOrder}><P2GTranslation translation="TRACKING.RESULT.ORDER.VALIDATE.LINK" /></P2GLink>
              </P2GGrid>
            }
          </P2GGrid>
        </P2GAlert>
      }
      {props.color === "info" &&
        <div style={{paddingTop: '16px', paddingBottom: '16px'}}>
          <P2GGrid container spacing={1} wrap='nowrap' direction='column'>
            <P2GGrid item>
              <P2GTranslation defaults="" translation={props.message} options={props.options} components={props.components} >
                {props.children}
              </P2GTranslation>
            </P2GGrid>
            {props.showOptions && props.showChat &&
              <P2GGrid item>
                <P2GChatLink
                  loadContext={props.loadChatContext}
                  orderReference={props.orderReference.toString()}
                  onOpenChat={props.onChatStarted}
                  onCloseChat={props.onChatEnded}
                >
                  <P2GTranslation translation="TRACKING.RESULT.ISSUE.CHAT" />
                </P2GChatLink>
              </P2GGrid>
            }
            {props.showOptions && (props.showChat && (props.helpLink || props.infoLink)) &&
              <P2GGrid item>
                /
              </P2GGrid>
            }
            {props.showOptions && props.helpLink &&
              <P2GGrid item>
                <P2GLink href={props.helpLink}><P2GTranslation translation="TRACKING.RESULT.ISSUE.HELP" /></P2GLink>
              </P2GGrid>
            }
            {props.showOptions && props.infoLink &&
              <P2GGrid item>
                <P2GLink href={props.infoLink}><P2GTranslation translation="TRACKING.RESULT.ISSUE.INFO" /></P2GLink>
              </P2GGrid>
            }
            {props.showOptions && props.showContact &&
              <P2GGrid item>
                <P2GTranslation translation="TRACKING.RESULT.ISSUE.CONTACT" />
              </P2GGrid>
            }
            {!props.showOptions && props.onValidateOrder && (props.showChat || props.showContact || props.infoLink || props.helpLink) &&
              <P2GGrid item>
                <P2GLink onClick={props.onValidateOrder}><P2GTranslation translation="TRACKING.RESULT.ORDER.VALIDATE.LINK" /></P2GLink>
              </P2GGrid>
            }
          </P2GGrid>
        </div>
      }
    </React.Fragment>
  );
}

interface ITrackingIssue {
  tracking: Tracking,
  onOpenValidation: () => void,
  loadChatContext: (profile: string) => Promise<ChatContext>,
  onChatStarted: () => void,
  onChatEnded: (start?: Date | null, end?: Date | null) => void
  headingVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  courierName: string
}

const TrackingIssues: React.FC<ITrackingIssue> = (props) => {
  const t = props.tracking;
  const id = t.order.orderLineId;

  const sharedProps = { showOptions: true, onValidateOrder: props.onOpenValidation, loadChatContext: props.loadChatContext, onChatStarted: props.onChatStarted, onChatEnded: props.onChatEnded };
  const isDomestic = t.order.collectionCountryIso2Code === t.order.deliveryCountryIso2Code;

  const lastTrackingEventScan = GetLastTrackingEventTimeStamp(t);
  const showHeldByCustomsDelayedMessage = lastTrackingEventScan ?
      t.hasHeldInCustomsParcel && lastTrackingEventScan.getTime() < GetRelativeTimestampByDays(4) && t.isOwner : false;
  const estimatedDeliveryHasPassed = HasEstimatedDeliveryDatePassed(t);
  const isNotTrackingInTransit = lastTrackingEventScan ?
      !t.complete &&
      !estimatedDeliveryHasPassed &&
      !t.hasRTSParcel &&
      !t.hasHeldInCustomsParcel &&
      lastTrackingEventScan.getTime() < GetRelativeTimestampByDays(4)
      : false;

  return (
    <React.Fragment>
      {t.hasDamagedParcel &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.DAMAGETITLE" message="TRACKING.RESULT.ISSUE.DAMAGE" showChat={true} showContact={false} headingVariant={props.headingVariant} {...sharedProps} />
      }

      {!t.complete && t.hasLostParcel &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.LOSTTITLE" message="TRACKING.RESULT.ISSUE.LOST" showChat={false} showContact={false} headingVariant={props.headingVariant} {...sharedProps} />
      }

      {!t.complete && t.hasDelayedParcel && !t.hasAddressIssueParcel && !t.hasDamagedParcel &&
        <TrackingIssueMessage color="info" orderReference={id} title="TRACKING.RESULT.ISSUE.DELAYTITLE" message="TRACKING.RESULT.ISSUE.DELAY" showChat={false} showContact={false} headingVariant={props.headingVariant} {...sharedProps} />
      }

      {!t.complete && t.hasHeldInCustomsParcel && !t.hasRTSParcel && !showHeldByCustomsDelayedMessage &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.HELDCUSTOMSTITLE" message="TRACKING.RESULT.ISSUE.HELDCUSTOMS" components={[<P2GLink href="/service-centre/caseheldcustoms" />]} options={{courierName: props.courierName}} showChat={false} showContact={false} headingVariant={props.headingVariant} {...sharedProps}>
        TRACKING.RESULT.ISSUE.HELDCUSTOMSTITLE
        </TrackingIssueMessage>
      }

      {!t.complete && showHeldByCustomsDelayedMessage && !t.hasRTSParcel &&
          <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.HELDCUSTOMSTITLE" message="TRACKING.RESULT.ISSUE.HELDCUSTOMSDELAY" showChat={false} components={[<P2GLink href={`/service-centre/casetrackingdelaysandissues?selectedOrderline=${t.order.orderLineId}`} />]} showContact={false} headingVariant={props.headingVariant} {...sharedProps} >
            TRACKING.RESULT.ISSUE.HELDCUSTOMSTITLE
          </TrackingIssueMessage>
      }

      {!t.complete && t.hasProhibitedParcel &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.PROHIBITEDTITLE" message="TRACKING.RESULT.ISSUE.PROHIBITED" showChat={false} components={[<P2GLink href="/prohibited-items" />]} showContact={false} headingVariant={props.headingVariant} {...sharedProps}>
          TRACKING.RESULT.ISSUE.PROHIBITEDTITLE
        </TrackingIssueMessage>
      }

      {!t.complete && t.hasOversizeParcel &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.OVERSIZETITLE" message="TRACKING.RESULT.ISSUE.OVERSIZE" showChat={false} components={[<P2GLink href="/help-centre/parcels/question/packaging/how-to-weigh-and-measure-a-parcel" />]} showContact={false} headingVariant={props.headingVariant} {...sharedProps}>
          TRACKING.RESULT.ISSUE.OVERSIZETITLE
        </TrackingIssueMessage>
      }

      {!t.complete && t.hasRTSParcel && isDomestic &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.RTSTITLE" message="TRACKING.RESULT.ISSUE.RTS" showChat={false} components={[<P2GLink href="/service-centre/select/choose?utm_content=RTS_Enquiry_Link_Domestic" />]} showContact={false} headingVariant={props.headingVariant} {...sharedProps} >
          TRACKING.RESULT.ISSUE.RTSTITLE
        </TrackingIssueMessage>
      }

      {!t.complete && t.hasRTSParcel && !isDomestic &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.RTSTITLE" message="TRACKING.RESULT.ISSUE.RTSINTERNATIONAL" showChat={false} components={[<P2GLink href="/service-centre/select/choose?utm_content=RTS_Enquiry_Link_International" />]} showContact={false} headingVariant={props.headingVariant} {...sharedProps} >
          TRACKING.RESULT.ISSUE.RTSTITLE
        </TrackingIssueMessage>
      }

      {!t.complete && t.hasAddressIssueParcel &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.ADDRESSISSUETITLE" message="TRACKING.RESULT.ISSUE.ADDRESSISSUE" showChat={true} showContact={false} headingVariant={props.headingVariant} {...sharedProps} />
      }

      {!t.complete && t.hasFailedDeliveryParcel && !t.hasRTSParcel &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.FAILEDDELIVERYTITLE" message="TRACKING.RESULT.ISSUE.FAILEDDELIVERY" showChat={true} showContact={false} headingVariant={props.headingVariant} {...sharedProps} />
      }

      {!t.complete && t.hasAttemptedDeliveryParcel && !t.hasFailedDeliveryParcel && !t.hasRTSParcel &&
        <TrackingIssueMessage color="info" orderReference={id} title="TRACKING.RESULT.ISSUE.ATTEMPTEDDELIVERYTITLE" message="TRACKING.RESULT.ISSUE.ATTEMPTEDDELIVERY" showChat={false} showContact={false} headingVariant={props.headingVariant} {...sharedProps} />
      }

      {!t.hasFailedDeliveryParcel && !t.hasAttemptedDeliveryParcel && !t.hasDamagedParcel && !t.hasLostParcel && !t.hasDelayedParcel && !t.hasHeldInCustomsParcel && !t.hasProhibitedParcel && !t.hasOversizeParcel && !t.hasRTSParcel && !t.hasAddressIssueParcel && !t.isLate && !t.possiablyLost && !isNotTrackingInTransit &&
        <TrackingIssueMessage color="error" orderReference={id} title="TRACKING.RESULT.ISSUE.GENERICTITLE" message="TRACKING.RESULT.ISSUE.GENERIC" showChat={false} showContact={false} headingVariant={props.headingVariant} {...sharedProps} />
      }

      {!t.complete && !t.hasRTSParcel && isNotTrackingInTransit && !((t.isLate && !t.hasDelayedParcel && !t.hasAddressIssueParcel)) &&
          <TrackingIssueMessage color="info" orderReference={id} title="TRACKING.RESULT.ISSUE.INTRANSITTITLE" message="TRACKING.RESULT.ISSUE.INTRANSITNOTTRACKED" showChat={false} showContact={false} headingVariant={props.headingVariant} {...sharedProps} />
      }

      {!t.complete && !t.hasDamagedParcel && !t.hasFailedDeliveryParcel && !t.possiablyLost && !t.hasRTSParcel && ((t.isLate && !t.hasDelayedParcel && !t.hasAddressIssueParcel)) && !showHeldByCustomsDelayedMessage &&
        <TrackingIssueMessage color="info" title="TRACKING.RESULT.ISSUE.INTRANSITTITLE" message="TRACKING.RESULT.ISSUE.LATE" orderReference={id} showChat={false} headingVariant={props.headingVariant} {...sharedProps}>
          TRACKING.RESULT.ISSUE.INTRANSITTITLE
        </TrackingIssueMessage>
      }

      {!t.complete && !t.hasDamagedParcel && !t.hasRTSParcel && !t.hasHeldInCustomsParcel && t.possiablyLost && !showHeldByCustomsDelayedMessage && !t.isOwner &&
          <TrackingIssueMessage color="info" title="TRACKING.RESULT.ISSUE.INTRANSITTITLE" message="TRACKING.RESULT.ISSUE.POSSIBLYLOST" components={[<P2GLink href={"/service-centre/select?caseType=NotDelivered"} />]} orderReference={id} showChat={false} headingVariant={props.headingVariant} {...sharedProps}>
            TRACKING.RESULT.ISSUE.INTRANSITTITLE
          </TrackingIssueMessage>
      }

      {!t.complete && !t.hasDamagedParcel && !t.hasRTSParcel && !t.hasHeldInCustomsParcel && t.possiablyLost && !showHeldByCustomsDelayedMessage && t.isOwner &&
          <TrackingIssueMessage color="info" title="TRACKING.RESULT.ISSUE.INTRANSITTITLE" message="TRACKING.RESULT.ISSUE.POSSIBLYLOST" components={[<P2GLink href={`/service-centre/select?caseType=NotDelivered&id=${t.order.orderLineId}`} />]} orderReference={id} showChat={false} headingVariant={props.headingVariant} {...sharedProps}>
            TRACKING.RESULT.ISSUE.INTRANSITTITLE
          </TrackingIssueMessage>
      }
    </React.Fragment>
  );
}

export default TrackingIssues;
